import { Configuration } from '@azure/msal-browser';

export interface Config {
  auth: Configuration | null;
  logoutUrl: string;
  loginUrl: string;
  graphUrl: string;
  gatekeeperUrl: string;
  companyUrl: string;
  hiddenRoutes: string[];
  isQA: boolean;
  userMediaPrivilege: any;
  pliUrl?: string;
  digitalAssetsUrl?: string;
  digitalProductSupportUrl?: string;
  supportUrl?: string;
  defaultA11ySettings: any;
}

type Environment = 'dev' | 'dev-next' | 'qa01' | 'stage' | 'production' | 'demo';

export const isQA = (env: string): boolean => env === 'qa01' || env === 'dev' || env === 'dev-next';

const getConfig = (env: Environment, { graphUrl, loginUrl, gatekeeperUrl }): Config => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const Config = env ? require(`./${env}`).default : require(`./dev`).default;
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const auth = require(`./auth`).default;

  return {
    ...Config,
    graphUrl,
    loginUrl,
    gatekeeperUrl,
    auth,
    isQA: isQA(env),
    defaultA11ySettings: {
      displaySettings: {
        contentScaling: 100,
        animations: false,
      },
      audioSettings: {
        displayAudioControls: false,
        volume: 100,
        muteSounds: false,
      },
      closedCaptionsSettings: {
        displayCCControl: false,
        showClosedCaptions: false,
        closedCaptionSize: 16,
      },
      videoNarrationSettings: {
        showSettings: false,
      },
    },
  };
};

export default getConfig(process.env.REACT_APP_BUILD_ENV as Environment, {
  graphUrl: process.env.REACT_APP_GRAPH_URL,
  loginUrl: process.env.REACT_APP_LOGIN_URL,
  gatekeeperUrl: process.env.REACT_APP_GATEKEEPER_URL,
});
